import {
  GET_SALES_EVENT_TYPES_REQUESTED,
  GET_SALES_EVENT_TYPES_SUCCEEDED,
  GET_SALES_EVENT_TYPES_FAILED,
} from './constants'
import DataMapper from '../../utils/dataMapper'

export const defaultState = { byId: {} }

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case GET_SALES_EVENT_TYPES_REQUESTED:
      return { ...state }

    case GET_SALES_EVENT_TYPES_SUCCEEDED:
      const byId = DataMapper.objectsById(payload.salesEventTypes)

      return {
        ...state,
        byId
      }

    case GET_SALES_EVENT_TYPES_FAILED:
      return { ...state }

    default:
      return state
  }
}
